import React, { useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import "./../../../css/app.css";
import mqtt_topics from "./../../../mqtt/mqtt_topics";
import { useAlert } from "react-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { confirmAlert } from "react-confirm-alert";
import { useHistory } from "react-router-dom";
import { manageRequest } from "../../../core/tools.js";
import EnterButton from "./EnterButton.jsx";
let seniorpass = "";
let clientpass = "";
let userpass = "";
let saspass = "";

const Tools = (props) => {
  const [requestCheck, setRequestCheck] = useStateIfMounted(false);
  const [waitDeviceResponse, setWaitDeviceResponse] = useStateIfMounted(false);
  const [instantFaultPresence, setInstantFaultPresence] =
    useStateIfMounted(false);
  let history = useHistory();
  const mac = mqtt_topics.choosenmac;
  const sdstatustopic =
    mqtt_topics.fixed_topic_part + mac + mqtt_topics.sdformatstatus_topic;
  const logstopic = mqtt_topics.fixed_topic_part + mac + "/LogRetrieve";
  const diagramtopic = mqtt_topics.fixed_topic_part + mac + "/Diagram";
  const alert = useAlert();

  function listenforDiagram() {
    props.mqttClient.subscribe(diagramtopic);
    props.mqttClient.on("message", handleMqttdiagramMessage);
  }

  function handleMqttdiagramMessage(topic, message) {
    if (topic !== diagramtopic) return;
    try {
      const parsedMessage = JSON.parse(message.toString());
      setInstantFaultPresence(!!parsedMessage.gAlarm);
    } catch (error) {
      // Optionally log or handle the error
      // console.error('Failed to parse message:', error);
    }
  }

  const formatauthenticationoptions = {
    //senior pass
    customUI: ({ onClose }) => {
      if (!requestCheck && !waitDeviceResponse) {
        return (
          <div className="alert">
            <h1 className="alert__title">SD Format Authentication</h1>
            <p className="alert__body">Enter password to proceed:</p>
            <input
              id="formatpasswordinput"
              type="password"
              maxLength="30"
              autoFocus="autoFocus"
              onKeyPress={(e) => handleKeyPress(e, "formatpasswordbutton")}
            />
            <button
              onClick={() => {
                let enteredpasswordauthoritylevel = checkparameterspasswor(
                  document.getElementById("formatpasswordinput").value,
                );
                if (
                  enteredpasswordauthoritylevel == "SAS" ||
                  enteredpasswordauthoritylevel == "Senior"
                ) {
                  confirmAlert(formatoptions);
                } else {
                  onClose();
                  alert.show("Invalid password.", {
                    type: "error",
                    position: "middle",
                  });
                }
              }}
              className="btn btn-primary"
              id="formatpasswordbutton"
            >
              Enter
            </button>
            &nbsp;
            <button className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
          </div>
        );
      } else {
        onClose();
      }
    },
  };
  const eraseFaultoptions = {
    //client pass
    customUI: ({ onClose }) => {
      if (!requestCheck && !waitDeviceResponse) {
        return (
          <div className="alert">
            <h1 className="alert__title">Erase Fault Authentication</h1>
            <p className="alert__body">Enter password to proceed:</p>
            <input
              id="formatpasswordinput"
              type="password"
              maxLength="30"
              autoFocus="autoFocus"
              onKeyPress={(e) => handleKeyPress(e, "formatpasswordbutton")}
            />
            <button
              onClick={() => {
                let enteredpasswordauthoritylevel = checkparameterspasswor(
                  document.getElementById("formatpasswordinput").value,
                );
                if (
                  enteredpasswordauthoritylevel == "SAS" ||
                  enteredpasswordauthoritylevel == "Senior" ||
                  enteredpasswordauthoritylevel == "Client"
                ) {
                  confirmAlert(erasefaultsoptions);
                } else {
                  onClose();
                  alert.show("Invalid password.", {
                    type: "error",
                    position: "middle",
                  });
                }
              }}
              className="btn btn-primary"
              id="formatpasswordbutton"
            >
              Enter
            </button>
            &nbsp;
            <button className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
          </div>
        );
      } else {
        onClose();
      }
    },
  };
  const formatoptions = {
    customUI: ({ onClose }) => {
      if (!requestCheck && !waitDeviceResponse) {
        return (
          <div className="alert">
            <h1 className="alert__title">Micro SD Card Format</h1>
            <p className="alert__body">Proceed?</p>
            <EnterButton
              buttonName="Yes"
              onClickAction={() => {
                startsdformat();
                onClose();
              }}
            />
            &nbsp;
            <button className="btn btn-secondary" onClick={onClose}>
              No
            </button>
          </div>
        );
      } else {
        onClose();
      }
    },
  };

  function checkparameterspasswor(enteredpass) {
    /*console.log("enteredpass_" + enteredpass);
    console.log("seniorpass_" + seniorpass);
    console.log("clientpass_" + clientpass);
    console.log("userpass_" + userpass);*/
    if (enteredpass == saspass) {
      return "SAS";
    } else if (enteredpass == seniorpass) {
      return "Senior";
    } else if (enteredpass == clientpass) {
      return "Client";
    } else if (enteredpass == userpass) {
      return "User";
    } else {
      return "";
    }
  }
  function parametersonKeyPress(e) {
    if (e.key === "Enter") {
      document.getElementById("parameterpasswordbutton").click();
      return false;
    }
    return true;
  }
  function handleKeyPress(e, buttonId) {
    //console.log("buttonId:" + buttonId);
    if (e.key === "Enter") {
      const button = document.getElementById(buttonId);
      if (button) {
        button.click(); // Trigger the button click
        e.preventDefault(); // Prevent default behavior of "Enter" key
      } else {
        console.warn(`Button with ID "${buttonId}" not found.`);
      }
    }
  }
  const parametersoptions = {
    customUI: ({ onClose }) => {
      return (
        <div className="alert">
          <h1 className="alert__title">Parameters Authentication</h1>
          <p className="alert__body">Enter parameter password to proceed:</p>
          <input
            id="parameterpasswordinput"
            type="password"
            maxLength="30"
            autoFocus="autoFocus"
            onKeyPress={parametersonKeyPress}
          />
          <button
            onClick={() => {
              let enteredpasswordauthoritylevel = checkparameterspasswor(
                document.getElementById("parameterpasswordinput").value,
              );
              if (enteredpasswordauthoritylevel != "") {
                history.push({
                  pathname: "/param",
                  mqttClient: props.mqttClient,
                  enteredpasswordauthoritylevel: enteredpasswordauthoritylevel,
                });
              } else {
                alert.show("Invalid password", {
                  type: "error",
                  position: "middle",
                });
              }
              onClose();
            }}
            className="btn btn-primary"
            id="parameterpasswordbutton"
          >
            Enter
          </button>
          &nbsp;
          <button className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
        </div>
      );
    },
  };
  const erasefaultsoptions = {
    customUI: ({ onClose }) => {
      if (!requestCheck && !waitDeviceResponse) {
        return (
          <div className="alert">
            <h1 className="alert__title">Erase Fault logs</h1>
            <p className="alert__body">Proceed ?</p>
            <EnterButton
              buttonName="Yes"
              onClickAction={() => {
                ProceedErasingFaults();
                onClose();
              }}
            />
            &nbsp;
            <button className="btn btn-secondary" onClick={onClose}>
              No
            </button>
          </div>
        );
      } else {
        onClose();
      }
    },
  };
  const eraseinstantfaultsoptions = {
    customUI: ({ onClose }) => {
      if (!requestCheck && !waitDeviceResponse) {
        return (
          <div className="alert">
            <h1 className="alert__title">Clear Instant Fault</h1>
            <p className="alert__body">Proceed ?</p>
            <EnterButton
              buttonName="Yes"
              onClickAction={() => {
                ProceedErasinginstantFault();
                onClose();
              }}
            />
            &nbsp;
            <button className="btn btn-secondary" onClick={onClose}>
              No
            </button>
          </div>
        );
      } else {
        onClose();
      }
    },
  };
  const startsdformat = async () => {
    if (!requestCheck && !waitDeviceResponse) {
      setRequestCheck(true);
      await new Promise((resolve) => setTimeout(resolve, 100));
      if (
        await manageRequest(
          "check",
          "Get Log",
          localStorage.getItem("token"),
          localStorage.getItem("username"),
          mqtt_topics.choosenmac,
        )
      ) {
        setRequestCheck(false);
        await new Promise((resolve) => setTimeout(resolve, 100));
        mqtt_topics.busy_Requesting_Data = true;
        props.mqttClient.publish(
          mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
          mqtt_topics.sdformat_topic,
        );
        mqtt_topics.busy_Requesting_Data = false;
        props.mqttClient.subscribe(sdstatustopic);
        props.mqttClient.on("message", handleMqttMessage);
        setWaitDeviceResponse(true);
      } else {
        setRequestCheck(false);
        alert.show(
          mqtt_topics.choosenid + " is busy right now. Please try again later.",
          {
            type: "info",
            position: "middle",
          },
        );
      }
    }
  };
  const ProceedErasingFaults = async () => {
    if (!requestCheck && !waitDeviceResponse) {
      await new Promise((resolve) => setTimeout(resolve, 100));
      if (localStorage.getItem("fl_of_" + mac) != "1") {
        return alert.show(
          mqtt_topics.choosenid +
            " device is not compatible with fault retrieval. For more information, contact support.",
          {
            type: "info",
            position: "middle",
          },
        );
      }
      setRequestCheck(true);
      await new Promise((resolve) => setTimeout(resolve, 100));
      if (
        await manageRequest(
          "check",
          "Get Log",
          localStorage.getItem("token"),
          localStorage.getItem("username"),
          mqtt_topics.choosenmac,
        )
      ) {
        setRequestCheck(false);
        await new Promise((resolve) => setTimeout(resolve, 100));
        mqtt_topics.busy_Requesting_Data = true;
        props.mqttClient.publish(
          mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
          JSON.parse(
            JSON.stringify(
              '{ "action": "Erase Faults","token":"' +
                localStorage.getItem("token") +
                '","username":"' +
                localStorage.getItem("username") +
                '"}',
            ),
          ),
        );
        mqtt_topics.busy_Requesting_Data = false;
        props.mqttClient.subscribe(logstopic);
        props.mqttClient.on("message", handleMqttMessage);
        setWaitDeviceResponse(true);
      } else {
        setRequestCheck(false);
        alert.show(
          mqtt_topics.choosenid + " is busy right now. Please try again later.",
          {
            type: "info",
            position: "middle",
          },
        );
      }
    }
  };
  const ProceedErasinginstantFault = async () => {
    if (!requestCheck && !waitDeviceResponse) {
      await new Promise((resolve) => setTimeout(resolve, 100));
      if (localStorage.getItem("fr_of_" + mac) != "1") {
        return alert.show(
          mqtt_topics.choosenid +
            " This device is not compatible with instant fault clearing. For more information, please contact support.",
          {
            type: "info",
            position: "middle",
          },
        );
      }
      setRequestCheck(true);
      await new Promise((resolve) => setTimeout(resolve, 100));
      if (
        await manageRequest(
          "check",
          "Reset Fault",
          localStorage.getItem("token"),
          localStorage.getItem("username"),
          mqtt_topics.choosenmac,
        )
      ) {
        setRequestCheck(false);
        await new Promise((resolve) => setTimeout(resolve, 100));
        mqtt_topics.busy_Requesting_Data = true;
        props.mqttClient.publish(
          mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
          JSON.parse(
            JSON.stringify(
              '{ "action": "Reset Fault","token":"' +
                localStorage.getItem("token") +
                '","username":"' +
                localStorage.getItem("username") +
                '"}',
            ),
          ),
        );
        mqtt_topics.busy_Requesting_Data = false;
        props.mqttClient.subscribe(logstopic);
        props.mqttClient.on("message", handleMqttMessage);
        setWaitDeviceResponse(true);
      } else {
        setRequestCheck(false);
        alert.show(
          mqtt_topics.choosenid + " is busy right now. Please try again later.",
          {
            type: "info",
            position: "middle",
          },
        );
      }
    }
  };
  function handleMqttMessage(topic, message) {
    if (topic === sdstatustopic) {
      // message is Buffer
      message = JSON.parse(message.toString());
      alert.show("Micro SD Status:" + message.value, {
        type: "info",
        position: "middle",
      });
      cleanwhenfinish(sdstatustopic);
      setWaitDeviceResponse(false);
    } else if (topic === logstopic) {
      message = JSON.parse(message.toString());
      alert.show(message.LogRetrieveStatus, {
        type: "info",
        position: "middle",
      });
      cleanwhenfinish(logstopic);
      setWaitDeviceResponse(false);
    }
  }
  useEffect(() => {
    seniorpass = localStorage.getItem("seniorpass_of_" + mac);
    clientpass = localStorage.getItem("clientpass_of_" + mac);
    userpass = localStorage.getItem("userpass_of_" + mac);
    saspass = localStorage.getItem("saspass_of_" + mac);
    listenforDiagram();
  }, []);

  //when componenet unmount
  useEffect(
    () => () => {
      props.mqttClient.unsubscribe(diagramtopic);
      props.mqttClient.removeListener("message", handleMqttdiagramMessage);
    },
    [],
  );
  function cleanwhenfinish(topic) {
    props.mqttClient.unsubscribe(topic);
    props.mqttClient.removeListener("message", handleMqttMessage);
  }
  const goToUpdatePage = async () => {
    if (props.passlevel == "client") {
      //only sas and senior
      alert.show("You don't have permission to perform this action.", {
        type: "error",
        position: "middle",
      });
      return;
    }
    if (!requestCheck && !waitDeviceResponse) {
      //if (localStorage.getItem("fu") == "1") {
      setRequestCheck(false);
      await new Promise((resolve) => setTimeout(resolve, 100));
      if (
        await manageRequest(
          "check",
          "Firmware Upgrade",
          localStorage.getItem("token"),
          localStorage.getItem("username"),
          mqtt_topics.choosenmac,
        )
      ) {
        setRequestCheck(true);
        await new Promise((resolve) => setTimeout(resolve, 100));
        history.push({
          pathname: "/update",
          mqttClient: props.mqttClient,
        });
      } else {
        setRequestCheck(false);
        alert.show(
          mqtt_topics.choosenid + " is busy right now. Please try again later.",
          {
            type: "info",
            position: "middle",
          },
        );
      }
      /* } else {
        alert.show(
          mqtt_topics.choosenid +
            " device is not compatible with online firmware upgrade. For more information, contact support.",
          {
            type: "info",
          }
        );
      }*/
    }
  };
  const goToLogPage = async (logsorfaults) => {
    if (!requestCheck && !waitDeviceResponse) {
      if (localStorage.getItem(logsorfaults + "_of_" + mac) == "1") {
        setRequestCheck(false);
        await new Promise((resolve) => setTimeout(resolve, 100));
        if (
          await manageRequest(
            "check",
            "Get Log",
            localStorage.getItem("token"),
            localStorage.getItem("username"),
            mqtt_topics.choosenmac,
          )
        ) {
          setRequestCheck(true);
          await new Promise((resolve) => setTimeout(resolve, 100));
          history.push({
            pathname: "/logs",
            mqttClient: props.mqttClient,
            goingto: logsorfaults,
          });
        } else {
          setRequestCheck(false);
          alert.show(
            mqtt_topics.choosenid +
              " is busy right now. Please try again later.",
            {
              type: "info",
              position: "middle",
            },
          );
        }
      } else {
        alert.show(
          mqtt_topics.choosenid +
            " device is not compatible with " +
            (logsorfaults == "fl" ? "fault" : "log") +
            " retrieval. For more information, contact support.",
          {
            type: "info",
            position: "middle",
          },
        );
      }
    }
  };
  return (
    <div className="row">
      <div className="col">
        <div className="card text-center bg-light toolcard">
          <div className="card-body">
            <p className="card-title">Parameters</p>
            <img
              className="tools"
              src={require("./../../../images/parameter.png")}
              onClick={() =>
                /*alert.show("Action is prohibited.", { type: "error" })*/
                confirmAlert(parametersoptions)
              }
            />
          </div>
        </div>
      </div>
      <div className="col">
        <div className="card text-center bg-light faulttoolcard">
          <div className="card-body" style={{ position: "relative" }}>
            <p className="card-title">Faults</p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                className="tools"
                title="Erase all fault logs"
                src={require("./../../../images/erasefaults.png")}
                onClick={() => confirmAlert(eraseFaultoptions)}
                style={{
                  position: "relative",
                }} // Ensure the image is positioned correctly
              />
              &nbsp; | &nbsp;
              <img
                className="tools"
                title="View faults"
                src={require("./../../../images/fault.png")}
                onClick={() => goToLogPage("fl")}
                style={{
                  position: "relative",
                }} // Ensure the image is positioned correctly
              />
              &nbsp;
              {instantFaultPresence && (
                <>
                  | &nbsp;
                  <img
                    className="tools"
                    title="Clear Genset Fault"
                    src={require("./../../../images/clearinstantfault.png")}
                    onClick={() => {
                      confirmAlert(eraseinstantfaultsoptions);
                    }}
                    style={{
                      position: "relative",
                    }} // Ensure the image is positioned correctly
                  />
                </>
              )}
            </div>

            {/* Spinner overlay */}
            <div
              className="spinner-border text-primary"
              style={{
                visibility:
                  !requestCheck && !waitDeviceResponse ? "hidden" : "visible",
                position: "absolute",
                top: "50%",
                left: "50%",
                width: "2rem",
                height: "2rem",
                zIndex: 10, // Ensure spinner is on top
                marginTop: "-1rem", // Half of the spinner's height
                marginLeft: "-1rem", // Half of the spinner's width
              }}
            ></div>
          </div>
        </div>
      </div>

      <div className="col">
        <div className="card text-center bg-light toolcard">
          <div
            className="card-body"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <p className="card-title">Micro SD Format</p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
              }}
            >
              <img
                className="tools"
                src={require("./../../../images/sd.png")}
                onClick={() => {
                  if (props.passlevel == "client") {
                    //only sas and senior
                    alert.show(
                      "You don't have permission to perform this action.",
                      {
                        type: "error",
                        position: "middle",
                      },
                    );
                    return;
                  }
                  confirmAlert(formatauthenticationoptions);
                }}
              />
              <div
                className="spinner-border text-primary"
                style={{
                  visibility:
                    !requestCheck && !waitDeviceResponse ? "hidden" : "visible",
                  position: "absolute", // Keeps the spinner on top of the image
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div className="col">
        <div className="card text-center bg-light toolcard">
          <div
            className="card-body"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <p className="card-title">Logs</p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
              }}
            >
              <img
                className="tools"
                src={require("./../../../images/log-file.png")}
                onClick={() => goToLogPage("lr")}
              />
              <div
                className="spinner-border text-primary"
                style={{
                  visibility:
                    !requestCheck && !waitDeviceResponse ? "hidden" : "visible",
                  position: "absolute", // Position the spinner absolutely within the container
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div className="col">
        <div className="card text-center bg-light toolcard">
          <div
            className="card-body"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <p className="card-title">Firmware Update</p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
              }}
            >
              <img
                className="tools"
                src={require("./../../../images/update.png")}
                onClick={() => goToUpdatePage()}
              />
              <div
                className="spinner-border text-primary"
                style={{
                  visibility:
                    !requestCheck && !waitDeviceResponse ? "hidden" : "visible",
                  position: "absolute", // Keeps the spinner on top of the image
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Tools;
